import Lenis from '@studio-freight/lenis';
import Rellax from 'rellax';
import { wrapCharSpan } from './_wrapCharSpan';
import { GsapAnimation } from '../gsap/_gsap';
import { scrollTrigger } from './_scrollTrigger';
import { simplyFade } from './_simplyFade';
import { imgEffect } from './_imgEffect';
import { smoothScroll } from './_smoothScroll';

// Gsapアニメーションクラスのインスタンスを生成
const gsap = new GsapAnimation();

export const commonFunc = () => {
  window.addEventListener('load', () => {
    const openning = document.querySelector( '.c-openning' );
    openning.classList.add( 'is--fadeOut' );
  });

  // relaxの起動
  new Rellax('.rellax', {
    speed: -2,
    center: false,
    wrapper: null,
    round: true,
    vertical: true,
    horizontal: false,
  });

  // 慣性スクロールの起動
  window.LENIS = new Lenis();
  const raf = time => {
    LENIS.raf(time);
    requestAnimationFrame(raf);
  };
  requestAnimationFrame(raf);

  // ハンバーガーメニュー
  const burgerButton = document.getElementById('js-burgerButton');
  const globalNav = document.getElementById('js-globalNav');

  burgerButton.addEventListener('click', function () {
    if (this.classList.contains('is--open')) {
      this.classList.remove('is--open');
      globalNav.classList.remove('is--open');
    } else {
      this.classList.add('is--open');
      globalNav.classList.add('is--open');
    }
  });

  // 単純フェードインアニメーション
  window.addEventListener('load', simplyFade);

  // 画像エフェクト & フェードイン アニメーション
  window.addEventListener('load', imgEffect);

  /**
   * テキストスプリットアニメーション
   */
  {
    const textSplitElements = document.querySelectorAll('.gsap-textSplit');

    window.addEventListener('load', () => {
      textSplitElements.forEach(item => {
        item.innerHTML = wrapCharSpan(item.textContent);
        scrollTrigger(item, 50);
      });
    });

    window.addEventListener(
      'scroll',
      () => {
        textSplitElements.forEach(item => {
          if (item.classList.contains('is--scrollTrigger')) {
            gsap.textSplit(item);
          }
        });
      },
      { passive: true }
    );
  }

  /**
   * アンカー押下時のスムーススクロール
   */
  {
    const $anchorArr = [...document.querySelectorAll('a[href^="#"]')];

    $anchorArr.forEach($anchor => {
      $anchor.addEventListener('click', e => {
        e.preventDefault();
        smoothScroll(e.currentTarget.hash);
      });
    });
  }
};
